import {IController} from "angular";
import * as angular from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {LeanPlanningAlertsService} from "../../services/lean-planning-alerts.factory";
import {LeanPlanningDialogService} from "../../services/lean-planning-dialogs-service.factory";

export class planningConfigurationCtrl implements IController {
  configuration: any;
  branchId?: any;

  public activeButtomForMock: boolean = true;
  public daysList: any;
  public timeSlotDayKeys: any = {};
  public resourceTypes: any;

  constructor(private deliveriesRequestsService: DeliveriesRequestsService, private $log, private leanPlanningAlertsService: LeanPlanningAlertsService,
              private leanPlanningConstants, private resourcesConstants,
              private leanPlanningDialogService: LeanPlanningDialogService, private bringozLoaderService: BringozLoaderService) {
    this.daysList = this.leanPlanningConstants.days;
    this.resourceTypes = this.resourcesConstants.resourceTypes;
  }


  onEditDayTimeSlot(event, timeSlotKey) {
    const configurationCopy = angular.copy(this.configuration);
    this.leanPlanningDialogService.editDayTimeSlot(event, configurationCopy.timeSlotMap[timeSlotKey], timeSlotKey)
      .then((editedTimeSlots) => {
          configurationCopy.timeSlotMap[timeSlotKey] = editedTimeSlots;
          this.onActiveChange(configurationCopy)
        },
        () => {
          this.$log.info('Dialog Closed')
        }
      )
  }

  onActiveChange(configuration) {
    this.bringozLoaderService.on();
    this.deliveriesRequestsService.setAnalysisConfiguration(configuration, this.branchId)
      .then((updatedConfiguration) => {
        this.configuration = updatedConfiguration;
        this.leanPlanningAlertsService.updateRoutingSettingsSuccess();
      })
      .catch((error) => {
        this.leanPlanningAlertsService.updateRoutingSettingsError();
        this.$log.error('Failed to update routes settings @planningConfiguration@onActiveChange', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }
}


angular
  .module('bringoz.admin.lean-planning')
  .component('planningConfiguration', {
    bindings: {
      configuration: '<',
      branchId: '<?'
    },
    template: require('./planning-configuration.html').default,
    controller: planningConfigurationCtrl
  });
